import { render, staticRenderFns } from "./OptometristPrescriptions.vue?vue&type=template&id=d5e3f632&scoped=true&"
import script from "./OptometristPrescriptions.vue?vue&type=script&lang=js&"
export * from "./OptometristPrescriptions.vue?vue&type=script&lang=js&"
import style0 from "./OptometristPrescriptions.vue?vue&type=style&index=0&id=d5e3f632&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e3f632",
  null
  
)

export default component.exports